import CapitaStarDelinkPage from "containers/CapitaStarDelinkPage/CapitaStarDelinkPage";

const VehicleIUPage = () => {
	return <CapitaStarDelinkPage vehicleVariant />;
};

export default VehicleIUPage;
